export default {
  common: {
    labels: {
      onlyInstalled: "Uniquement Installé",
      showMore: "Afficher plus",
      showLess: "Afficher moins",
      reportDate: "Date du rapport",
      reportTime: "Heure du rapport",
      reportAtGlance: "Rapport en un coup d'œil",
      last24Hours: "Dernières 24 heures",
      fleetStatus: "Statut de la flotte",
      fleetSize: "Taille de la flotte",
      totalDevices: "Appareils totaux",
      addNewAlert: "Ajouter une nouvelle alerte",
      addNewRecepient: "Ajouter un nouveau destinataire",
      selectEVModel: "Sélectionner le modèle de véhicule électrique",
      selectHPModel: "Sélectionner le modèle de pompe à chaleur",
      reRunAnalysis: "Relancer l'analyse",
      devicesWith: "Appareils avec",
      logout: "Déconnexion",
      name: "Nom",
      email: "Email",
      nickname: "Surnom",
      openAsPage: "Ouvrir en tant que page",
      editDeviceDetails: "Modifier les détails de l'appareil",
      manageAlerts: "Gérer les alertes",
      noLocation: "Aucun emplacement trouvé pour ce dispositif",
      selectDeviceToCompare: "Sélectionnez un appareil à comparer",
      includeAmbientTemperature: "Inclure la température ambiante",
      startDate: "Date de début",
      endDate: "Date de fin",
      thisFieldIsRequired: "Ce champ est obligatoire",
      mustBeLessThan50Characters: "Doit comporter moins de 50 caractères",
      numberHasToBeBetween0And100: "Le nombre doit être compris entre 0 et 100",
      timeOfDay: "Heure de la journée",
      indicatesRequiredField: "Indique un champ obligatoire",
      editDetails: "Modifier les détails",
      noReportAvailable: "Aucun rapport n'est disponible pour aucune semaine",
      noDataAvailable: "Aucune donnée disponible",
      resetView: "Réinitialiser la vue",
      fleetOverview: "Aperçu de la flotte",
      functionalLocation: "Emplacement fonctionnel",
    },
    words: {
      total: "Total",
      this: "Ceci",
      all: "Tous",
      watchList: "Liste de surveillance",
      schedule: "Programmation",
      client: "Client",
      recepients: "Destinataires",
      more: "Plus",
      devices: "Appareils",
      search: "Rechercher",
      reset: "Réinitialiser",
      save: "Enregistrer",
      language: "Langue",
      english: "Anglais",
      french: "Français",
      back: "Retour",
      clear: "Effacer",
      to: "à",
      standard: "Standard",
      commuter: "Commutateur",
      nonCommuter: "Non Commutateur",
      edit: "Modifier",
      cancel: "Annuler",
      saveAs: "Enregistrer sous",
      alert: "Alerte",
      last: "Dernier",
      preferences: "Préférences",
    },
    messages: {
      success: {
        deviceDetailsSaved: "Détails de l'appareil enregistrés avec succès!",
        good: "Bien",
      },
      warnings: {
        temperatureError: "Erreur de température",
        temperatureInvestigationWarning: "Appareils avec une alerte de température qui peuvent nécessiter une enquête",
        missedMessages: "Messages manqués",
        noCommunications: "Aucune communication",
      },
      errors: {},
      filter: {
        filterApplied: "Filtre appliqué avec succès",
        filterRemoved: "Filtre supprimé avec succès",
        filterError: "Erreur lors de l'application du filtre",
      },
    },
    measure: {
      kVA: "kVA",
      kW: "kW",
    },
    times: {
      days: {
        sunday: "Dimanche",
        monday: "Lundi",
        tuesday: "Mardi",
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
      },
      months: {
        january: "Janvier",
        february: "Février",
        march: "Mars",
        april: "Avril",
        may: "Mai",
        june: "Juin",
        july: "Juillet",
        august: "Août",
        september: "Septembre",
        november: "Novembre",
        december: "Décembre",
        jan: "Jan",
        feb: "Fév",
        mar: "Mar",
        apr: "Avr",
        my: "Mai",
        jun: "Juin",
        jul: "Juil",
        aug: "Août",
        sep: "Sept",
        nov: "Nov",
        dec: "Déc",
      },
      time: {
        today: "Aujourd'hui",
        second: "Seconde",
        seconds: "Secondes",
        minute: "Minute",
        minutes: "Minutes",
        hr: "Heure",
        hrs: "Heures",
        day: "Jour",
        days: "Jours",
        week: "Semaine",
        weeks: "Semaines",
        month: "Mois",
        months: "Mois",
        year: "Année",
        years: "Années",
        secondsAge: "Il y a quelques secondes",
        minutesAge: "Il y a quelques minutes",
        hoursAgo: "Il y a quelques heures",
        daysAgo: "Il y a quelques jours",
        weeksAgo: "Il y a quelques semaines",
        monthsAgo: "Il y a quelques mois",
        yearsAgo: "Il y a quelques années",
        last24Hours: "Dernières 24 heures",
        last7Days: "7 derniers jours",
        last28Days: "28 derniers jours",
        lastWeek: "La semaine dernière",
        last4Weeks: "4 dernières semaines",
        last8Weeks: "8 dernières semaines",
        last3Months: "Últimos 3 meses",
        last6Months: "Últimos 6 meses",
        last1Year: "Último año",
        TwentyFourHours: "24 heures",
        SevenDays: "7 jours",
        TwentyEightDays: "28 jours",
      },
    },
  },
  views: {
    Alerts: {},
    Analytics: {
      mainTitle: "Analytique",
      pageTitle: "Aperçu",
      charts: {
        totalPower: {
          title: "Puissance Totale",
          xLabel: "Capacité (kVA)",
          yLabel: "Horodatage",
          bottomLabelMaxCapacity: "Capacité Max Totale",
          bottomLabelTotalCapacity: "Capacité Totale Utilisée",
        },
        issues: {
          title: "Problèmes",
          xLabel: "Problèmes",
          yLabel: "Nombre d'appareils",
          hAxis: {
            HasCapacityUnderLimit: {
              label: "Capacité Sous-Limite",
              tooltip: "Appareils avec une capacité inférieure à 15%",
            },
            HasCapacityOverLimit: {
              label: "Capacité Sur-Limite",
              tooltip: "Appareils avec une capacité supérieure à 85%",
            },
            HasMissedMessages: {
              label: "Messages Manqués",
              tooltip: "Appareils avec des messages manqués.",
            },
            HasImbalance: {
              label: "Déséquilibre de Phase",
              tooltip: "Appareils avec un déséquilibre de phase supérieur à 90%",
            },
            HasCurrentOverLimit: {
              label: "Courant Sur-Limite",
              tooltip: "Appareils avec un courant supérieur à la limite",
            },
            HasLowBattery: {
              label: "Batterie Faible",
              tooltip: "Appareils avec une batterie faible.",
            },
            HasNoPower: {
              label: "Pas de Puissance",
              tooltip: "Appareils sans puissance",
            },
            HasTemperatureOutsideRange: {
              label: "Température hors plage",
              tooltip: "Appareils avec une température hors plage",
            },
            HasTemperatureOverLimit: {
              label: "Température Sur-Limite",
              tooltip: "Appareils avec une température supérieure à la limite",
            },
            HasTemperatureSenseError: {
              label: "Alerte de température",
              tooltip: "Appareils avec une alerte de température",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "Appareils",
          columns: {
            id: "ID de l'appareil",
            type: "Type de moniteur",
            t_name: "Nom du transformateur",
            t_size: "Taille du transformateur",
            capacity: {
              text: "Capacité",
              tooltip:
                "% de la capacité totale disponible utilisée. (Médiane totale du courant * 230/1000) / Évaluation de puissance (%)",
            },
            power: {
              text: "Puissance totale",
              tooltip: "La somme des mesures de puissance maximales de toutes les phases mesurées pendant la période.",
            },
            l_message: "Dernier message",
          },
        },
      },
    },
    Asset: {
      deviceDetails: {
        transformerName: {
          label: "Nom du transformateur",
        },
        transformerNo: {
          label: "Numéro du transformateur",
        },
        transformerSize: {
          label: "Taille du transformateur",
        },
        assetId: {
          label: "Identifiant d'actif",
        },
        deviceStatus: {
          label: "État de l'appareil",
        },
        deviceVoltage: {
          label: "Tension de l'appareil",
        },
        installationDate: {
          label: "Date d'installation",
        },
        connectedMPRNs: {
          label: "MPRNs connectés",
        },
        commuterArea: {
          label: "Zone de navetteurs",
        },
      },
      latestMessage: {
        title: "Dernier message",
        currentPH1: {
          label: "Courant PH1",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        currentPH2: {
          label: "Courant PH2",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        currentPH3: {
          label: "Courant PH3",
          suffix: "A",
          helptext: "(Med/Max)",
        },
        temperature: {
          label: "Température",
          suffix: "°C",
          helptext: "(Med/Max)",
        },
      },
      calculatedReadings: {
        title: "Mesures calculées",
        totalPower: {
          label: "Puissance totale",
          suffix: "kVA",
        },
        capacity: {
          label: "Capacité",
          suffix: "%",
        },
        imbalance: {
          label: "Déséquilibre",
          suffix: "%",
        },
        utilization: {
          label: "Utilisation",
          suffix: "%",
        },
      },
      tabs: {
        charts: {
          label: "Graphiques",
        },
        messages: {
          label: "Messages",
        },
        evAnalysis: {
          label: "Analyse de VE",
        },
        hpAnalysis: {
          label: "Analyse de pompes à chaleur",
        },
      },
      charts: {
        chartConfig1: {
          title: "Sélectionnez un appareil à comparer",
          temp: {
            label: "Température (°C)",
            xAxis: "Horodatage",
            yAxis: "Température (°C)",
          },
          diff: {
            label: "Température (°C)",
            xAxis: "Horodatage",
            yAxis: "Température",
          },
          imbalance: {
            label: "Déséquilibre et Médiane de Courant (A)",
            labelDailyStats: "Déséquilibre et Courant (A)",
            xAxis: "Horodatage",
            yAxis: "Charge Max (A)",
            yBarAxis: "Déséquilibre (%)",
          },
          totalPower: {
            label: "Puissance Totale et Médianes de Courant (A)",
            labelDailyStats: "Puissance Totale et Courant (A)",
            xAxis: "Horodatage",
            yAxis: "Charge Maximale (A)",
            yBarAxis: "Puissance Totale (kVA)",
          },
          imbalanceMax: {
            label: "Déséquilibre et courant maximum (A)",
            xAxis: "Horodatage",
            yAxis: "Charge maximale",
            yBarAxis: "Déséquilibre",
          },
          totalPowerMax: {
            label: "Puissance totale et courant maximum (A)",
            xAxis: "Horodatage",
            yAxis: "Charge maximale (A)",
            yBarAxis: "Puissance totale (kVA)",
          },
        },
      },
      tables: {
        messages: {
          columns: {
            seqNo: {
              text: "N° de séquence",
            },
            messageTime: {
              text: "Heure du message",
            },
            missedMessage: {
              text: "Message manqué",
            },
            lqi: {
              text: "LQI",
            },
            medCurrentPH1: {
              text: "Courant Médian PH1",
              suffix: "A",
            },
            maxCurrentPH1: {
              text: "Courant Max PH1",
              suffix: "A",
            },
            medCurrentPH2: {
              text: "Courant Médian PH2",
              suffix: "A",
            },
            maxCurrentPH2: {
              text: "Courant Max PH2",
              suffix: "A",
            },
            medCurrentPH3: {
              text: "Courant Médian PH3",
              suffix: "A",
            },
            maxCurrentPH3: {
              text: "Courant Max PH3",
              suffix: "A",
            },
            maxTemp: {
              text: "Température Max.",
              suffix: "°C",
            },
            medTemp: {
              text: "Température Méd.",
              suffix: "°C",
            },
            capacity: {
              text: "Capacité",
              suffix: "%",
              tooltip:
                "% de la capacité totale disponible utilisée. (Courant médian total * 230/1000) / Cote de puissance (%)",
            },
            imbalance: {
              text: "Déséquilibre",
              suffix: "%",
              tooltip:
                "Déséquilibre de courant entre les phases. Différence maximale entre la phase et le courant moyen / Courant moyen (%) *pour les 3 phases seulement",
            },
          },
        },
      },
    },
    Assets: {
      pageTitle: "Aperçu des appareils",
      deviceCoverage: "Vérifier la couverture des appareils",
      charts: {
        capacity: {
          title: "Capacité",
          tooltip:
            "L'analyse de la capacité mesure la quantité de capacité utilisée pour chaque transformateur et la stratifie en surutilisée, normale ou sous-performante.",
          header: {
            capacity: "Capacité",
            numberOfDevices: "Nombre d'appareils",
          },
          data: {
            underperforming: {
              text: "Sous-performant",
              message: "Appareils en dessous de la limite de courant - Moins de 15% de la capacité",
            },
            normal: {
              text: "Normal",
              message: "Appareils avec un courant optimal - Entre 15% et 85% de la capacité",
            },
            overutilised: {
              text: "Surutilisé",
              message: "Appareils au-dessus de la limite de courant - Plus de 85% de la capacité",
            },
          },
        },
        imbalance: {
          title: "Déséquilibre",
          tooltip:
            "Le déséquilibre mesure la quantité de déséquilibre sur les 3 phases utilisées pour chaque transformateur et le stratifie par déséquilibre ou normal.",
          header: {
            imbalanceStatus: "État de déséquilibre",
            numberOfDevices: "Nombre de dispositifs",
          },
          data: {
            normal: {
              label: "Normal",
              message: "Appareils sans déséquilibre.",
            },
            imbalance: {
              label: "Déséquilibre",
              message: "Appareils avec déséquilibre.",
            },
          },
        },
        powerChange: {
          title: "Changement de puissance",
          tooltip:
            "Le changement de puissance mesure la quantité de changement de puissance à chaque transformateur et le stratifie en anormal ou normal.",
          header: {
            powerChangeStatus: "État du changement de puissance",
            numberOfDevices: "Nombre de dispositifs",
          },
          data: {
            normal: {
              label: "Normal",
              message: "Dispositifs sans changement de puissance anormal.",
            },
            abnormal: {
              label: "Anormal",
              message: "Dispositifs avec changement de puissance anormal.",
            },
          },
        },
        batteryStatus: {
          title: "État de la batterie",
          tooltip:
            "Affiche l'état de la batterie de tous les appareils et les stratifie en fonction de la batterie haute, basse ou inconnue.",
          header: {
            batteryStatus: "État de la batterie",
            numberOfDevices: "Nombre d'appareils",
          },
          data: {
            highBattery: {
              label: "Batterie haute",
              message: "Appareils avec une batterie haute.",
            },
            lowBattery: {
              label: "Batterie faible",
              message: "Appareils avec une batterie faible.",
            },
            unknownBattery: {
              label: "Batterie inconnue",
              message: "Appareils avec une batterie inconnue.",
            },
          },
        },
        devicesCommunication: {
          title: "Communication des Appareils",
          tooltip:
            "Affiche la communication de tous les appareils et la stratifie en fonction des messages communiqués, des absences de communication ou des messages manqués.",
          header: {
            connectivity: "Connectivité",
            numberOfDevices: "Nombre d'appareils",
          },
          data: {
            communicated: {
              label: "Messages communiqués",
              message: "Appareils sans messages manqués",
            },
            noCommunications: {
              label: "Pas de Communication",
              message: "Appareils sans communication dans les dernières 24 heures",
            },
            missedMessages: {
              label: "Messages Manqués",
              message: "Appareils avec des messages manqués",
            },
          },
        },
        devicesStatus: {
          title: "Statut des dispositifs",
          tooltip:
            "Affiche les statuts/problèmes de tous les dispositifs et les stratifie par absence de problème, problème d'asymétrie, température hors plage, courant en dépassement, problème de communication, problème d'alimentation, problème de capteur de température, température en dépassement ou problème de batterie.",
          header: {
            deviceStatus: "Statut du dispositif",
            numberOfDevices: "Nombre de dispositifs",
          },
          data: {
            noIssue: {
              label: "Aucun problème",
              message: "Dispositifs sans problèmes.",
            },
            phaseImbalance: {
              label: "Asymétrie de phase",
              message: "Dispositifs avec une asymétrie maximale > 90%",
            },
            temperatureAlert: {
              label: "Alerte de température",
              message: "Dispositifs avec une alerte de température qui nécessite une enquête",
            },
            currentOverlimit: {
              label: "Courant en dépassement",
              message: "Dispositifs avec un courant en dépassement.",
            },
            communicationProblem: {
              label: "Problème de communication",
              message: "Dispositifs avec un problème de communication.",
            },
            noPower: {
              label: "Pas d'alimentation",
              message: "Dispositifs avec un problème d'alimentation.",
            },
            lowBattery: {
              label: "Batterie faible",
              message: "Dispositifs avec des problèmes de batterie.",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "",
          filters: {
            primary: {},
            secondary: {
              list_checkbox: {
                label: "Type de transformateur",
              },
              flags: {
                temperatureOverlimit: {
                  label: "Température limite dépassée",
                },
                currentOverlimit: {
                  label: "Courant limite dépassé",
                },
              },
              range: {
                transformerSize: {
                  label: "Taille du transformateur",
                },
                maxCurrentPH1: {
                  label: "Courant maximum PH1",
                },
                maxCurrentPH2: {
                  label: "Courant maximum PH2",
                },
                maxCurrentPH3: {
                  label: "Courant maximum PH3",
                },
                maxTemperature: {
                  label: "Température maximale",
                },
              },
            },
          },
          columns: {
            deviceId: {
              text: "Identifiant de l'appareil",
            },
            monitorType: {
              text: "Type de moniteur",
            },
            deviceName: {
              text: "Nom",
            },
            powerRating: {
              text: "Taille du transformateur",
            },
            totalPower: {
              text: "Puissance totale",
              tooltip: "La puissance maximale combinée de toutes les phases mesurées pendant la période.",
            },
            maxCapacity: {
              text: "Capacité max (%)",
              tooltip:
                "% de la capacité totale disponible en utilisation. (Courant Max Total * 230/1000) / PowerRating (%)",
            },
            maxImbalance: {
              text: "Déséquilibre Max (%)",
              tooltip:
                "Déséquilibre de courant entre les phases. Max différence entre la phase et le courant moyen / Courant moyen (%) *pour 3 phases seulement",
            },
            current0Max: {
              text: "Courant Max PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Température Max.",
            },
            isCommuterArea: {
              text: "Zone de navette",
            },
            isWatchlisted: {
              text: "",
            },
            moreActions: {
              text: "",
              labels: ["Modifier les détails"],
            },
          },
        },
      },
    },
    AssetSnapshotView: {},
    CoverageChecker: {},
    Device: {},
    DeviceCoverage: {},
    DeviceHome: {},
    Error: {},
    EVModelling: {
      charts: {
        maxEVSupported: {
          title: "Nombre maximum de VE supportées",
          labels: {
            maxEVs: "Max VE",
            numberOfDevices: "Nombre de dispositifs",
          },
        },
        maxHPSupported: {
          title: "HP Max Supporté",
          labels: {
            maxHP: "HP Max",
            numberOfDevices: "Nombre de Périphériques",
          },
        },
        firstYearOverCapacity: {
          title: "Première année de dépassement de capacité",
          labels: {
            xLabel: "Première année du problème",
            yLabel: "Nombre de dispositifs",
          },
        },
      },
      tables: {
        deviceEVMTable: {
          title: "",
          columns: {
            deviceId: {
              text: "Identifiant de l'appareil",
            },
            maxEVs: {
              text: "Max. VE",
            },
            maxEVHour: {
              text: "Heure de Max VE",
            },
            firstYearOverCapacity: {
              text: "Première année en surcapacité",
            },
            maxLoadDay: {
              text: "Jour de Max Charge",
            },
            minHeadroom: {
              text: "Marge minimale",
            },
            maxLoad: {
              text: "Charge Maximale",
            },
            maxLoadHour: {
              text: "Heure de Max Charge",
            },
          },
        },
      },
    },
    Home: {},
    HPModelling: {},
    Journey: {},
    Journeys: {},
    Location: {},
    LocationList: {},
    PoiReport: {},
    PowerdataAlerts: {
      title: "",
      tabs: {
        activeAlerts: {
          label: "Alertes actives",
        },
        manageAlerts: {
          label: "Gérer les alertes",
        },
      },
      alert: {
        alarm: {
          label: "Alarm",
        },
        maxCurrentPH1: {
          label: "Courant max. PH1",
        },
        medCurrentPH1: {
          label: "Courant moyen PH1",
        },
        maxCurrentPH2: {
          label: "Courant max. PH2",
        },
        medCurrentPH2: {
          label: "Courant moyen PH2",
        },
        maxCurrentPH3: {
          label: "Courant max. PH3",
        },
        medCurrentPH3: {
          label: "Courant moyen PH3",
        },
        maxTemperature: {
          label: "Température max.",
        },
        medTemperature: {
          label: "Température moyenne",
        },
        imbalance: {
          label: "Déséquilibre",
        },
        totalPower: {
          label: "Puissance totale",
        },
      },
      tables: {
        alerts: {
          columns: {
            alertId: {
              text: "Identifiant de l'alerte",
            },
            deviceId: {
              text: "Identifiant de l'appareil",
            },
            deviceType: {
              text: "Type d'appareil",
            },
            triggerField: {
              text: "Champ de déclenchement",
            },
            triggerValue: {
              text: "Valeur de déclenchement",
            },
            triggerOperator: {
              text: "Opérateur de déclenchement",
            },
            moreActions: {
              text: "",
              labels: ["Gérer les destinataires", "Modifier les détails", "Supprimer"],
            },
          },
        },
        activeAlerts: {
          columns: {
            alertId: {
              text: "ID de l'alerte",
            },
            deviceId: {
              text: "ID de l'appareil",
            },
            fullName: {
              text: "Nom complet",
            },
            deviceType: {
              text: "Type d'appareil",
            },
            triggerField: {
              text: "Champ déclencheur",
            },
            triggerValue: {
              text: "Valeur déclencheur",
            },
            actualValue: {
              text: "Valeur réelle",
            },
            triggerDate: {
              text: "Date de déclenchement",
            },
          },
        },
      },
    },
    PowerdataReports: {
      header: {},
    },
    PowerdataReportView: {},
    Profile: {
      userInformation: {
        title: "Informations de l'utilisateur",
      },
      preferences: {
        language: "Préférences linguistiques",
        theme: "Thème",
      },
      managePreferences: {
        title: "Gérer les préférences",
        defaultTab: "Onglet par défaut",
        manageSections: "Gérer les sections",
        arrangeSections: "Organiser les sections",
      },
    },
    Reports: {},
    Snapshot: {},
  },
  components: {
    AlertsTemplate: {
      labels: {
        deviceType: "Type d'appareil",
        triggerField: "Champ déclencheur",
        triggerValue: "Valeur déclencheur",
        device: "Dispositif",
        triggerOperator: "Opérateur de déclenchement",
      },
    },
    AreaChartVT: {},
    AssetSnapshot: {},
    ColumnChartVT: {},
    ComboChart: {},
    ComboChartVT: {},
    DataTableVT: {},
    DaysSelector: {},
    DialogVT: {
      contactVT: "Veuillez contacter VT...",
      desc: "Vous avez un accès limité aux fonctionnalités disponibles dans l'application. Veuillez contacter VT pour en savoir plus sur les fonctionnalités offertes.",
    },
    DiffAreaChart: {},
    DiffChart: {},
    DistributionBarVT: {},
    EditAssetDetails: {},
    EditLocationDetails: {},
    Error: {},
    EVModelDetails: {},
    EVModelEditDetails: {
      labels: {
        selectModel: "Sélectionnez le modèle",
        selectDayType: "Sélectionnez le type de journée",
        useCommuterStatus: "Utiliser le statut de navetteur",
        mostRecentWeekday: "Jour de semaine le plus récent",
        mostRecentWeekdayTooltip: "* Pour lequel il y a 24 heures de données de message",
        maxAnnualLoadDay: "Jour de charge annuelle maximale",
        evModelDetails: "Détails du modèle EV",
        chooseModelName: "Choisissez le nom du modèle",
        modelName: "Nom du modèle",
        indicatesRequiredField: "*indique un champ obligatoire",
        chargeRateWeekday: "Taux de charge (jour de semaine)",
        chargeRateWeekend: "Taux de charge (week-end)",
        chargeDurationWeekday: "Durée de charge (jour de semaine)",
        chargeDurationWeekend: "Durée de charge (week-end)",
        ratioOfHigh1: "Ratio de chargeurs de puissance élevée (7 kW) à basse puissance (3 kW) (%) [par EV = ",
        ratioOfHigh2: " kVA]",
        ratioOfBEV: "Ratio de véhicules BEV par rapport aux véhicules PHEV (%)",
        confidenceLevel: "Niveau de confiance % (distribution binomiale)",
        percentageOfPeopleWhoPurchase: "Pourcentage de personnes achetant une nouvelle voiture chaque année (%)",
        modifyProbalities: "Modifier les probabilités",
      },
      charts: {
        evForecast: {
          title: "Proportion prédite des ventes de voitures électriques par an (jusqu'en 2030)",
          label: "Prévisions de ventes de VE",
          xAxis: "Année",
          yAxis: "% de voitures électriques",
          vAxes: {
            title: "Ventes de VE (%)",
          },
          hAxis: {
            title: "Année",
          },
        },
        cumulProbChart: {
          title: "Probabilité qu'un chargeur EV consomme de l'électricité par heure",
          label: "Analyse de probabilité cumulée",
          xAxis: "Heure du jour",
          yAxis: "Probabilité de charge",
          vAxes: {
            title: "Probabilité de charge",
          },
          chartLabels: {
            0: "Horodatage",
            1: "Probabilité de charge (%)",
          },
        },
        powerLoadDataOnly: {
          title: {
            1: "Analyse de la Charge / Marge du Transformateur [ ",
            2: " ]",
          },
          label: "Charge du transformateur",
          yLabel: "Heure de la journée",
          xLabel: "Charge (kVa)",
          vAxes: {
            0: { title: "Charge (kVa)" },
            1: { title: "Marge de manœuvre (kVa)" },
          },
          chartLabels: {
            0: { title: "Heure du jour" },
            1: { title: "Charge Totale" },
            2: { title: "Marge de manoeuvre" },
            3: { title: "Charge maximale" },
          },
        },
        evModelChart: {
          title: "Analyse de la distribution binomiale - Nombre maximal de VE supplémentaires sur ce transformateur",
          label: "Analyse de la marge de manoeuvre des VE",
          xAxis: "Heure du jour",
          yAxis: "# Chargeurs VE",
          vAxes: {
            0: { title: "# Chargeurs VE" },
            1: { title: "MAX_EVS = " },
          },
          chartLabels: {
            0: { title: "Horodatage" },
            1: { title: "Nombre maximum de chargeurs" },
            2: { title: "Max EVs" },
          },
        },
        totalNewEVCharge: {
          title: "Nouveaux véhicules électriques prévus par an sur ce transformateur",
          label: "Ventes annuelles prévues de VE",
          xAxis: "Année",
          yAxis: "# Total de nouveaux chargeurs EV",
          vAxes: {
            title: "# Total de nouveaux chargeurs EV",
          },
          hAxis: {
            title: "Année",
          },
          chartLabels: {
            0: { title: "Année" },
            1: { title: "Nombre de véhicules électriques" },
            2: { title: "Première année de capacité excédentaire" },
          },
        },
      },
    },
    FleetReport: {},
    HomeContent: {},
    HPModelEditDetails: {
      filters: {
        modelName: {
          label: "Sélectionner le modèle",
        },
        dayType: {
          label: "Sélectionner le type de jour",
          tooltip: "Choisissez le jour le plus récent ou le pire jour de charge pour l'année",

          mostRecentWeekday: "Jour de semaine le plus récent",
          maxAnnualLoadDay: "Jour de charge annuelle maximale",
          mostRecentWeekdayTooltip: "* Pour lequel il y a 24 heures de données de message",
        },
        extremeScenerio: {
          label: "Scénario extrême ('1 sur 20')",
          tooltip: "Modèles pour les pics hivernaux exceptionnellement froids (par exemple -5 degrés)",
        },
      },
      title: "Détails du modèle HP",
      subTitle: "Nom du modèle",
      HPModelEdit: {
        labels: {
          chooseModelName: "Choisissez le nom du modèle",
          ratioOfNewBuildExistingHomes: {
            title: "Ratio de nouvelles constructions par rapport aux maisons existantes (%)",
            labelA: "Construction neuve",
            labelB: "Existant",
          },
          ratioOfDetachedvsSemi: {
            title: "Ratio de maisons individuelles par rapport aux maisons jumelées ou en rangée (%)",
            labelA: "Individuelle",
            labelB: "Jumelée/En rangée",
          },
          ratioOfHybridvsAir: {
            title: "Ratio de Pompe à Chaleur Hybride vs Pompe à Chaleur Air-Eau (%)",
            labelA: "Hybride",
            labelB: "Air-Eau",
          },
          ratioOfHighTemp: {
            title: "Ratio of High Temp (HT) vs Low Temp (LT) Air source HP (%)",
            labelA: "HT",
            labelB: "LT",
          },
          percentageOfPeopleWhoInstall: {
            title: "Pourcentage de personnes qui installent une pompe à chaleur par an (%)",
            labelA: "Probabilité",
          },
        },
      },
      charts: {
        loadProfiles: {
          title: "Profils de Charge Typiques (kW) des Pompes à Chaleur par Maison et Type de Pompe à Chaleur",
          label: "Profils de Charge des PC",
          xAxis: "Heure de la Journée",
          yAxis: "Charge des PC (kW)",
          vAxes: {
            0: { title: "Charge des PC (kW)" },
          },
        },
        HPLoadChart: {
          title: "Profil de charge estimé (kVA) de la pompe à chaleur par modèle",
          label: "Analyse de charge de la pompe à chaleur",
          xAxis: "Heure de la journée",
          yAxis: "Charge de la pompe à chaleur (kVA)",
          vAxes: {
            0: { title: "Charge de la pompe à chaleur (kVA)" },
          },
          labelA: "Horodatage",
          labelB: "Charge de HP (kVA)",
        },
        powerModel: {
          title: {
            0: "Analyse de la charge / marge du transformateur [",
            1: " ]",
          },
          label: "Charge du transformateur",
          xAxis: "Heure de la journée",
          yAxis: "Charge (kVa)",
          data: {
            0: "Horodatage",
            1: "Charge (KVa)",
          },
          vAxes: {
            0: { title: "Charge (kVa)" },
            1: { title: "Marge (kVa)" },
          },
          labelA: "Heure du jour",
          labelB: "Charge totale",
          labelC: "Marge de sécurité",
        },
        HPModel: {
          title: "Nombre maximal de HPs supplémentaires sur ce transformateur",
          label: "Analyse de la marge de puissance des HPs",
          xAxis: "Heure de la journée",
          yAxis: "# de pompes à chaleur",
          vAxes: {
            0: { title: "# de pompes à chaleur" },
            1: { title: "MAX_HPS = " },
          },
          labelA: "Horodatage",
          labelB: "Nombre maximal de pompes à chaleur",
        },
        HPCalculatedSales: {
          title: "Nouveaux HP prévus par an sur ce transformateur",
          label: "Ventes annuelles calculées de HP",
          xAxis: "Année",
          yAxis: "# Total de nouveaux HP",
          vAxes: {
            0: { title: "# Total de nouveaux HP" },
          },
          hAxis: {
            title: "Année",
          },
          labelA: "Année",
          labelB: "Nombre de HP",
        },
      },
    },
    InputSelectVT: {},
    KPIReport: {},
    LineChart: {},
    LineChartVT: {},
    LoaderVT: {},
    MapInfoWindow: {},
    MapInfoWindowPowerdataTemplate: {},
    MapInfoWindowTemplate: {},
    MapMarkerVT: {},
    MapsVT: {},
    MapTooltipVT: {},
    MinMaxChart: {},
    NavBar: {},
    OverviewCardsVT: {},
    PageHeader: {},
    POISnapshot: {},
    PowerDataMainReport: {
      title: "Voici le rapport d'aujourd'hui VT Electron",
      tables: {
        fleetStatus: {
          title: "État de la flotte",
          columns: {
            issue: {
              text: "Problème",
            },
            numberOfAssets: {
              text: "Nombre d'actifs",
            },
            percentageDevices: {
              text: "%",
            },
          },
        },
        devices: {
          columns: {
            name: {
              text: "Nom",
            },
            transformerSize: {
              text: "Taille du transformateur",
            },
            maxCapacity: {
              text: "Capacité maximale",
            },
            maxCurrent: {
              text: "Courant max PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Température max",
            },
            graph: {
              text: "",
            },
          },
        },
      },
    },
    PrimaryFiltersVT: {},
    RadialChartVT: {},
    ReportManagement: {},
    SecondaryFiltersVT: {},
    SelectVT: {},
    SnackBarVT: {},
    TooltipVT: {},
  },
};
